import { ChangeDetectionStrategy, Component, computed, inject, signal, viewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs';
import { PAGE } from '../../core';
import { BaseComponent, ConfirmationComponent } from '../../shared';
import { PatientFormComponent } from '../patient-form';


/**
* Patient create/edit page component.
*/
@Component({
	selector: 'patient-creation',
	templateUrl: './patient-creation.component.html',
	imports: [
		PatientFormComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PatientCreationComponent extends BaseComponent {

	public route = inject(ActivatedRoute);
	private readonly router = inject(Router);
	private readonly modalSrv = inject(NgbModal);

	private readonly patientFormCmp = viewChild(PatientFormComponent);

	isEdit = toSignal(this.route.queryParamMap.pipe(map(p => p.get('patientGuid') != null)), { initialValue: false });
	isBackToList = computed(() => this.isEdit() || this._previousPageList());

	private readonly _previousPageList = signal<boolean>(this.router.currentNavigation()?.extras.state?.['previousPageList'] ?? false);

	/**
	 * Handle back button click.
	 */
	back(): void {
		if (this.patientFormCmp()?.isFormDirty) {
			this.openConfirmModal();
		} else {
			this.returnToPreviousPage();
		}
	}

	/**
	* Open confirmation modal before navigate to previous page.
	*/
	private openConfirmModal(): void {
		if (!this.modalSrv.hasOpenModals()) {
			const modalRef = this.modalSrv.open(ConfirmationComponent, { centered: true, backdrop: 'static' });
			(modalRef.componentInstance as ConfirmationComponent).config = {
				title: this.labels().PATIENT_CREATION_COMPONENT_CANCEL_MODAL_TITLE,
				message: this.labels().PATIENT_CREATION_COMPONENT_CANCEL_MODAL_MESSAGE,
				cancelBtn: this.labels().PATIENT_CREATION_COMPONENT_CANCEL_MODAL_NO,
				confirmBtn: this.labels().PATIENT_CREATION_COMPONENT_CANCEL_MODAL_YES
			};
			modalRef.result.then(() => this.returnToPreviousPage()).catch(error => false);
		}
	}

	/**
	* Navigate to previous page.
	*/
	private returnToPreviousPage(): void {
		this.router.navigateByUrl(`/${this.isBackToList() ? PAGE.LIST : PAGE.DASHBOARD}`);
	}
}
